var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-content-loading',{attrs:{"width":300,"height":39}},[_c('rect',{attrs:{"x":"0","y":"0","width":"400","height":"39"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }